import { Link } from '@carbon/react';
import styles from './tia-card.module.scss';

export interface TiaProps {
  fields: Array<{
    key: string | null;
    value: string;
  }>;
  title: string | React.ReactNode;
  titleHref?: string;
  rightPanel?: React.ReactNode;
}

/**
 * Card row for the unit drill-down list. Renders the title (optionally as a
 * link), a 2-column grid of key/value fields, and an optional right-side
 * panel (e.g. a polygon thumbnail).
 * @param {TiaProps} props - The component props.
 * @return {JSX.Element} The card row.
 */
export const TiaCard = ({ fields, title, titleHref, rightPanel }: TiaProps) => {
  return (
    <div className={styles.container}>
      <div>
        <p className={styles.link}>
          {titleHref ? (
            <Link
              href={titleHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {title}
            </Link>
          ) : (
            title
          )}
        </p>
        <div className={styles.fields}>
          {fields.map(({ key, value }, index) => (
            <div key={key ?? `field-${index}`} className={styles.text}>
              {key !== null && <span className={styles.label}>{key}: </span>}
              {value}
            </div>
          ))}
        </div>
      </div>
      {rightPanel && <div>{rightPanel}</div>}
    </div>
  );
};
